import React from 'react';
import { Box, forwardRef } from '@chakra-ui/react';
import { getActionHeaderStyles } from './action-menu-header.theme';

export interface ActionMenuHeaderProps {
  children?: React.ReactNode;
}

/**
 * The `ActionMenuHeader` adds a top level header that should be the first child
 * of the `ActionMenuContent` component. This component will not be affixed to
 * the top of the menu.
 */
export const ActionMenuHeader = forwardRef<ActionMenuHeaderProps, 'div'>(
  ({ children, ...rest }, ref) => {
    return (
      <Box
        ref={ref}
        className="action-menu__header"
        sx={getActionHeaderStyles()}
        {...rest}
      >
        {children}
      </Box>
    );
  }
);
